import React from "react";

const Index = React.lazy(() => import("./index"));

export const BALANCE_SHEET_PATH = "/admin/balanceSheet";
export const BALANCE_SHEET_SCHEDULED_PATH = "/admin/scheduledForBalanceSheet";

export const balanceSheetRoutes = [
	{
		path: BALANCE_SHEET_SCHEDULED_PATH,
		name: "Scheduled For Balance Sheet",
		element: <Index />,
	},
	{
		path: BALANCE_SHEET_PATH,
		name: "Balance Sheet",
		element: <Index />,
	},
];
